import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import Card13 from "../Images/Profiles/Rashid.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function RashidSeggujja() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Rashid Seggujja - Laboratory Technical Manager"
        description="Mr. Rashid Seggujja is the Laboratory Technical Manager at CIRCODU with a Bachelor's Degree in Industrial and Organizational Psychology."
        keywords="Rashid Seggujja, Laboratory Technical Manager, CIRCODU, Bachelor's Degree, Industrial and Organizational Psychology"
        url="/rashid-seggujja"
        image={Card13}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Rashid Seggujja</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Rashid Seggujja
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card13} alt="Mr. Rashid Seggujja" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Rashid Seggujja</h1>
                <p className="profile-card__role">
                  Laboratory Technical Manager
                </p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Rashid holds a Bachelor's Degree in Industrial and
                  Organizational Psychology, a credential he earned from
                  Makerere University. His educational journey is further
                  enriched by a multitude of specialized certificates that
                  highlight his commitment to professional growth.
                </p>
                <p>
                  Among his accomplishments, Rashid has secured a certificate in
                  the Implementation of ISO/IEC 17025:2017, which underscores
                  his proficiency in maintaining the competence of testing and
                  calibration laboratories. He has also obtained a Certificate
                  in the Water Boiling Test Version 4.2.3, signifying his
                  expertise in evaluating cookstove emissions and efficiency
                  within controlled laboratory settings. Demonstrating his
                  proficiency, Rashid holds a Certificate in the Controlled
                  Cooking Test (C.C.T) Version 2.0, complemented by a
                  Certificate in CIRCODU Emissions Testing methods and
                  protocols. He is also certified in the testing of stoves using
                  Uganda Standard US 761, showcasing his adherence to
                  established industry benchmarks. Further substantiating his
                  capabilities, Rashid possesses a Certificate in conducting
                  internal Audits based on ISO:9001 and ISO/IEC 17025.
                  Additionally, he has earned recognition for his participation
                  and innovation within the IDDS Cookstoves 2016 initiative. His
                  commitment to quality management is affirmed by a Certificate
                  in Quality Management System based on ISO/IEC 17025:2017,
                  endorsed by the Uganda National Bureau of Standards (UNBS).
                </p>
                <p>
                  Rashid's professional trajectory encompasses valuable roles at
                  CIRCODU. He served as a Laboratory Technician from 2015 to
                  2019, contributing significantly to the organization's
                  endeavors. Presently, Rashid holds the esteemed position of
                  Technical Manager for CIRCODU's Cookstove Laboratory, a
                  testament to his evolving responsibilities and leadership
                  within the organization.
                </p>
                <p>
                  His character is characterized by focus, intelligence, and an
                  unwavering commitment to excellence. Rashid's interpersonal
                  skills are exemplified through his adeptness in multicultural
                  settings, where he thrives. His remarkable communication
                  skills, both written and oral, underscore his ability to
                  effectively convey ideas and collaborate with diverse
                  stakeholders.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/rasheed.seggujja"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256701447940"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:rashid.seggujja@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RashidSeggujja;
